import type { EntityConstructorForType, EntityOfType } from '@cognitoforms/model.js';
import type { FormEntry } from '@cognitoforms/types/server-types/forms/model/form-entry';
import type { PaymentToken } from '@cognitoforms/types/server-types/payment/model/payment-token';
import { PaymentTokenStatus } from '@cognitoforms/types/server-types/payment/model/payment-token-status';
import { SAVED_CARD_TOKEN_TYPE, type CardInfo, type PaymentTokenInfo } from './payment-types';

type SavedCardDetails = Partial<CardInfo> | null | undefined;

export function createSavedCardTokenInfo(paymentMethodId: string, card: SavedCardDetails): PaymentTokenInfo {
	return {
		Type: SAVED_CARD_TOKEN_TYPE,
		Token: paymentMethodId,
		DateCreated: new Date(),
		Status: PaymentTokenStatus.PendingPayment,
		SaveForFutureUse: false,
		IsLive: false,
		Card: {
			Country: card?.Country,
			Brand: card?.Brand,
			Last4: card?.Last4
		}
	};
}

export function isSavedCardToken(token: Pick<PaymentToken, 'Type'> | null | undefined): boolean {
	return token?.Type === SAVED_CARD_TOKEN_TYPE;
}

export class SavedCardTokenSelection {
	constructor(
		private readonly getEntry: () => EntityOfType<FormEntry> | null,
		private readonly restoreNewCardToken: () => void
	) { }

	select(card: SavedCardDetails, paymentMethodId?: string): void {
		const entry = this.getEntry();
		const entryMeta = entry?.Entry;
		if (!entryMeta)
			return;

		if (!card) {
			if (isSavedCardToken(entryMeta.PaymentToken)) {
				entryMeta.PaymentToken = null;
				this.restoreNewCardToken();
			}
			return;
		}

		const PaymentTokenType = (entry.meta.type.model.$namespace as any).Payment.PaymentToken as EntityConstructorForType<PaymentToken>;
		entryMeta.PaymentToken = new PaymentTokenType(createSavedCardTokenInfo(paymentMethodId ?? null, card));
	}
}
